import React, { useState } from 'react';

// کامپوننت آیکون‌های SVG بومی برای کارکرد ۱۰۰٪ آفلاین
const OfflineIcon = ({ name, color = '#fff', size = 24 }) => {
  const icons = {
    visibility: <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>,
    mic: <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>,
    description: <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>,
    smart_toy: <path d="M20 9V7c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 3.34 9 5H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6v-4h12v4zm0-6H6V7h12v6zM9 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm6 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"/>,
    precision_manufacturing: <path d="M15 22H9v-2h6v2zm7-11v2h-2.18c-.4 2.1-1.7 3.9-3.5 4.9l1.4 1.4-1.4 1.4-1.4-1.4c-1 .8-2.2 1.3-3.5 1.5V20h-2v-1.2c-1.3-.2-2.5-.7-3.5-1.5l-1.4 1.4-1.4-1.4 1.4-1.4C5.1 14.9 3.8 13.1 3.4 11H1.2V9h2.2C3.8 6.9 5.1 5.1 6.9 4.1L5.5 2.7l1.4-1.4 1.4 1.4c1-.8 2.2-1.3 3.5-1.5V0h2v1.2c1.3.2 2.5.7 3.5 1.5l1.4-1.4 1.4 1.4-1.4 1.4c1.8 1 3.1 2.8 3.5 4.9H22v2zm-10 4c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5z"/>
  };

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={{ display: 'block' }}>
      {icons[name] || null}
    </svg>
  );
};

export default function AIExperienceCenter() {
  const [activeDemo, setActiveDemo] = useState(1);

  return (
    <div style={{ backgroundColor: '#0c0d12', color: '#fff', padding: '40px', borderRadius: '24px', border: '1px solid rgba(168, 85, 247, 0.2)' }}>
      <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#a855f7', fontSize: '24px', fontWeight: '700' }}>BINOTECH AI Experience Center</h2>
      <p style={{ textAlign: 'center', color: '#94a3b8', marginBottom: '40px', fontSize: '14px' }}>محیط شبیه‌سازی لایو راهکارهای هوش مصنوعی بینوتک در صنایع تولیدی (نسخه آفلاین)</p>
      
      {/* منوی انتخاب دموها */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px', marginBottom: '40px' }}>
        {[
          { id: 1, title: '۱. Pose & PPE Detection', icon: 'visibility' },
          { id: 2, title: '۲. Meeting Assistant', icon: 'mic' },
          { id: 3, title: '۳. OCR & Document AI', icon: 'description' },
          { id: 4, title: '۴. AI Factory Chat', icon: 'smart_toy' },
          { id: 5, title: '۵. Predictive Maintenance', icon: 'precision_manufacturing' }
        ].map(demo => (
          <button 
            key={demo.id}
            onClick={() => setActiveDemo(demo.id)}
            style={{
              backgroundColor: activeDemo === demo.id ? '#a855f7' : '#131520',
              color: '#fff', padding: '15px', borderRadius: '14px', border: 'none', cursor: 'pointer',
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', fontWeight: 'bold',
              transition: 'all 0.3s', boxShadow: activeDemo === demo.id ? '0 0 15px rgba(168, 85, 247, 0.4)' : 'none',
              fontFamily: 'inherit'
            }}
          >
            <OfflineIcon name={demo.icon} color={activeDemo === demo.id ? '#fff' : '#a855f7'} size={26} />
            <span style={{ fontSize: '13px', marginTop: '4px' }}>{demo.title}</span>
          </button>
        ))}
      </div>

      {/* باکس نمایش دموی فعال */}
      <div style={{ backgroundColor: '#131520', borderRadius: '20px', padding: '30px', minHeight: '350px', border: '1px solid rgba(255,255,255,0.03)' }}>
        {activeDemo === 1 && <PosePPEDemo />}
        {activeDemo === 2 && <MeetingAssistantDemo />}
        {activeDemo === 3 && <OcrDocumentDemo />}
        {activeDemo === 4 && <FactoryChatDemo />}
        {activeDemo === 5 && <PredictiveMaintenanceDemo />}
      </div>
    </div>
  );
}

/* ──── ۱. شبیه‌ساز لایو POSE & PPE DETECTION ──── */
function PosePPEDemo() {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
      <div style={{ position: 'relative', backgroundColor: '#000', height: '260px', borderRadius: '14px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: '#4ade80', zIndex: 2, textAlign: 'center', border: '2px dashed #4ade80', padding: '15px', borderRadius: '8px', background: 'rgba(0,0,0,0.6)' }}>
          <span style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px' }}>[ کلاه ایمنی: تایید شده ۱۰۰٪ ]</span>
          <span style={{ fontSize: '12px' }}>زاویه ارگونومی کمر: ۴۵ درجه (ریسک متوسط)</span>
        </div>
        <div style={{ position: 'absolute', width: '100%', height: '100%', opacity: 0.3, background: 'linear-gradient(45deg, #1e1b4b, #311042)' }} />
      </div>
      <div>
        <h4 style={{ color: '#a855f7', marginTop: 0, fontSize: '18px' }}>پایش هوشمند تجهیزات و ارگونومی کارکنان</h4>
        <p style={{ color: '#94a3b8', fontSize: '14px', lineHeight: '24px', textAlign: 'justify' }}>این ماژول به صورت همزمان استفاده از کلاه و جلیقه ایمنی (PPE) را چک کرده و با تحلیل ساختار بدنی (Pose Estimation) میزان فشار روی ستون فقرات کارگران خط تولید را محاسبه می‌کند.</p>
        <span style={{ color: '#4ade80', fontSize: '13px', fontWeight: 'bold' }}>● پردازش زنده ویدیو آفلاین (بدون نیاز به سرور خارجی)</span>
      </div>
    </div>
  );
}

/* ──── ۲. شبیه‌ساز لایو MEETING ASSISTANT ──── */
function MeetingAssistantDemo() {
  return (
    <div>
      <h4 style={{ color: '#a855f7', marginTop: 0, fontSize: '18px' }}>تبدیل گفتار به متن جلسات کارخانه (موتور آفلاین بینوتک)</h4>
      <div style={{ backgroundColor: '#0c0d12', padding: '15px', borderRadius: '12px', marginBottom: '15px', borderLeft: '4px solid #a855f7' }}>
        <p style={{ margin: 0, fontSize: '14px', color: '#e2e8f0', lineHeight: '24px' }}><strong>مدیر تولید:</strong> "تجهیزات خط شماره ۳ فردا ساعت ۱۰ صبح نیاز به کالیبراسیون دارن، حتماً تیم فنی بررسی کنه."</p>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
        <div style={{ backgroundColor: '#1e1b4b', padding: '15px', borderRadius: '12px' }}>
          <h5 style={{ margin: '0 0 10px 0', color: '#c084fc', fontSize: '14px' }}>📌 خلاصه هوشمند هوش مصنوعی</h5>
          <span style={{ fontSize: '13px', color: '#cbd5e1' }}>دستور کالیبراسیون خط ۳ برای فردا صادر شد.</span>
        </div>
        <div style={{ backgroundColor: '#14532d', padding: '15px', borderRadius: '12px' }}>
          <h5 style={{ margin: '0 0 10px 0', color: '#4ade80', fontSize: '14px' }}>⚡ اقدامات لازم (Action Items)</h5>
          <span style={{ fontSize: '13px', color: '#cbd5e1' }}>تخصیص خودکار تسک به واحد نگهداری و تعمیرات.</span>
        </div>
      </div>
    </div>
  );
}

/* ──── ۳. شبیه‌ساز لایو OCR & DOCUMENT AI ──── */
function OcrDocumentDemo() {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px' }}>
      <div style={{ backgroundColor: '#1e293b', padding: '20px', borderRadius: '12px', border: '1px dashed #64748b', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <span style={{ color: '#94a3b8', fontSize: '13px' }}>[ تصویر فرم اسکن شده کارخانه ]</span>
        <h5 style={{ margin: '10px 0 5px 0', fontSize: '14px' }}>برگه گزارش روزانه ماشین‌آلات</h5>
      </div>
      <div>
        <h4 style={{ color: '#a855f7', marginTop: 0, fontSize: '18px' }}>استخراج داده ساختاریافته از اسناد کاغذی</h4>
        <table style={{ width: '100%', fontSize: '13px', color: '#cbd5e1', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}><td style={{ padding: '10px 0', color: '#94a3b8' }}>کد دستگاه:</td><td>MCH-4092</td></tr>
            <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}><td style={{ padding: '10px 0', color: '#94a3b8' }}>وضعیت کارکرد:</td><td style={{ color: '#4ade80', fontWeight: 'bold' }}>عادی</td></tr>
            <tr><td style={{ padding: '10px 0', color: '#94a3b8' }}>نام تکنسین:</td><td>مهندس مرادی</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ──── ۴. شبیه‌ساز لایو AI FACTORY CHAT ──── */
function FactoryChatDemo() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '280px', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <div style={{ alignSelf: 'flex-start', backgroundColor: '#334155', padding: '10px 15px', borderRadius: '14px', maxWidth: '80%', fontSize: '14px' }}>
          میزان راندمان خط تولید ۲ در هفته گذشته چقدر بوده؟
        </div>
        <div style={{ alignSelf: 'flex-end', backgroundColor: '#7e22ce', padding: '10px 15px', borderRadius: '14px', maxWidth: '80%', fontSize: '14px', lineHeight: '22px' }}>
          🤖 <strong>دستیار بینوتک:</strong> راندمان خط ۲ در هفته گذشته ٪۸۴.۵ بوده است. دستگاه پرس هیدرولیک با ۳ بار توقف، بیشترین عامل کاهش راندمان برآورد شده است.
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
        <input type="text" placeholder="سوال خود را از سیستم آفلاین کارخانه بپرسید..." disabled style={{ flex: 1, backgroundColor: '#0c0d12', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '10px', padding: '12px', color: '#fff', fontFamily: 'inherit' }} />
        <button style={{ backgroundColor: '#a855f7', border: 'none', padding: '10px 20px', borderRadius: '10px', color: '#fff', fontFamily: 'inherit', fontWeight: 'bold' }}>ارسال</button>
      </div>
    </div>
  );
}

/* ──── ۵. شبیه‌ساز لایو PREDICTIVE MAINTENANCE ──── */
function PredictiveMaintenanceDemo() {
  return (
    <div>
      <h4 style={{ color: '#a855f7', marginTop: 0, fontSize: '18px' }}>سیستم پیش‌بینی زمان خرابی و نگهداری پیشگیرانه صنعتی</h4>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginTop: '20px' }}>
        <div style={{ backgroundColor: '#0c0d12', padding: '20px', borderRadius: '16px', textAlign: 'center', border: '1px solid rgba(239,68,68,0.2)' }}>
          <span style={{ fontSize: '12px', color: '#94a3b8' }}>توربین اصلی خط ۱</span>
          <h5 style={{ margin: '10px 0', color: '#ef4444', fontSize: '18px', fontWeight: '700' }}>ریسک خرابی: ۸۷٪</h5>
          <span style={{ fontSize: '11px', color: '#fca5a5' }}>تعویض بلبرینگ تا ۴۸ ساعت آینده</span>
        </div>
        <div style={{ backgroundColor: '#0c0d12', padding: '20px', borderRadius: '16px', textAlign: 'center', border: '1px solid rgba(34,197,94,0.2)' }}>
          <span style={{ fontSize: '12px', color: '#94a3b8' }}>کمپرسور بخش تهویه</span>
          <h5 style={{ margin: '10px 0', color: '#4ade80', fontSize: '18px', fontWeight: '700' }}>سلامت سیستم: ۹۸٪</h5>
          <span style={{ fontSize: '11px', color: '#bbf7d0' }}>کارکرد نرمال بدون نیاز به تعمیر</span>
        </div>
      </div>
    </div>
  );
}